// Libraries
import _debounce from 'lodash/debounce'

// Shared
import { getItem } from 'shop-components/api/items'

export const composeItem = ({ data, included }) => {
  const item = {
    id: data.id,
    type: data.type,
    ...data.attributes,
    photos: [],
    products: []
  }

  included.forEach(({ id, type, attributes, relationships }) => {
    switch (type) {
      case 'bundle_items': {
        if (data.type !== 'bundles') return

        const productGroup = included.find(({ id: _id }) => _id === relationships.product_group.data.id)
        const photo = included.find(({ id: _id }) => _id === productGroup.attributes.photo_id)
        const products = productGroup.relationships.products.data
          .map(({ id }) => ({
            id,
            ...included.find(({ id: _id }) => _id === id).attributes
          }))
          .map((product) => {
            const photo = included.find(({ id: _id }) => _id === product.photo_id)?.attributes

            if (photo) {
              return {
                ...product,
                photo
              }
            }

            return product
          })

        if (photo && !item.photos.find(({ id: _id }) => _id === photo.id)) {
          item.photos.push({
            id: photo.id,
            ...photo.attributes
          })
        }

        item.products.push({
          id,
          ...attributes,
          product_group: {
            id: productGroup.id,
            ...productGroup.attributes,
            products
          }
        })

        break
      }
      case 'products': {
        if (data.type !== 'product_groups') return

        const photo = included.find(({ id: _id }) => _id === attributes.photo_id)

        if (photo && !item.photos.find(({ id: _id }) => _id === photo.id)) {
          item.photos.push({
            id: photo.id,
            ...photo.attributes
          })
        }

        item.products.push({
          id,
          ...attributes
        })

        break
      }
    }
  })

  return item
}

const fetchRequest = (id, dispatch) => {
  dispatch({
    type: 'PRODUCTS_FETCH_START',
    payload: { id }
  })

  getItem(id).then(({ data }) => {
    const item = composeItem(data)

    dispatch({ type: 'PRODUCTS_FETCH_SUCCESS', payload: { records: [item] } })
  })
}

const fetchDebounced = _debounce(fetchRequest, 50)

export const fetchItem = (id) => (dispatch) => {
  return fetchDebounced(id, dispatch)
}

export const updateConfiguration = ({ id, itemId, variationId }) => (dispatch) => {
  dispatch({
    type: 'PRODUCT_UPDATE_CONFIGURATION',
    payload: { id, itemId, variationId }
  })
}
